/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     参数 API
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const general_adress = process.env.VUE_APP_GENERAL_API_HOST

export function getallSenApi(params) {
  return request({
    url: general_adress + '/dev/sen/getAll',
    method: 'get',
    params
  })
}

export function listSenApi(params) {
  return request({
    url: general_adress + '/dev/sen/list',
    method: 'get',
    params
  })
}

export function getSenApi(params) {
  return request({
    url: '?c=dev&a=sen&do=get',
    method: 'get',
    params
  })
}

export function postSenApi(data) {
  return request({
    url: '?c=dev&a=sen&do=post',
    method: 'post',
    data
  })
}

export function deleteSenApi(data) {
  return request({
    url: '?c=dev&a=sen&do=delete',
    method: 'post',
    data
  })
}

export function rankSenApi(data) {
  return request({
    url: general_adress + '/dev/sen/display',
    method: 'post',
    data
  })
}

export function saveSysSenApi(data) {
  return request({
    url: general_adress + '/dev/saveSysSen',
    method: 'post',
    data
  })
}

export function getSysSenListApi(params) {
  return request({
    url: general_adress + '/dev/getSysSenList',
    method: 'get',
    params
  })
}